var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all"},[_vm._v("总交易次数：21912"),_c('span',[_vm._v("学时总计：8827.5")])]),_c('div',{attrs:{"id":"lesson"}})])}]

export { render, staticRenderFns }